import { FormikHelpers } from "formik";
import { Col, Row } from "react-bootstrap";
import Form from "../../common/Form";
import Link from "../../common/Link";
import { registrazioneFormFields } from "../../config/formFields/Registrazione";
import { getAuth, registration } from "../../services/AuthService";
import './auth.css';
import { RegistrationFormType } from "../../helpers/interfaces/auth";

const initialValues: any = {
  username: '',
  email_address: '',
  password: '',
  repeat_password: '',
  tos: false
};

export default function RegistrazionePage() {
  const auth = getAuth();

  async function registrazioneSubmit(
    values: RegistrationFormType,
    formikHelpers: FormikHelpers<any>
  ): Promise<void> {
    if (values.password !== values.repeat_password) {
      alert('Errore: i campi "password" e "Ripeti password" non coincidono');
      return;
    }

    if (values.password.toLowerCase().includes(values.username.toLowerCase().replace(/\W/g, ''))) {
      alert('Errore: La password non può contenere il nome utente');
      return;
    }

    const emailParts = values.email_address.split('@');
    const emailDomainParts = emailParts[1].split('.')

    if (
      values.password.toLowerCase().includes(emailParts[0]) ||
      values.password.toLowerCase().includes(emailDomainParts[0]) ||
      values.password.toLowerCase().includes(emailDomainParts[1])
    ) {
      alert("Errore: La password non può contenere parti dell'indirizzo email");
      return;
    }

    await registration({
      email: values.email_address,
      nome: values.username,
      password: values.password
    }).then((response) => {
      alert('Registrazione riuscita con successo');
    }).catch((reason: any) => {
      alert('Si è verificato un errore durante la registrazione: ' + reason)
    });
  }

  const formFields = registrazioneFormFields();

  return auth !== null ? (
    <span>
      <h4>Attenzione:</h4>
      Sei loggato come <strong>{auth.nomeCognome}</strong>,
      per iniziare la registrazione di un nuovo utente per favore prima effettua il{' '}
      <Link href="/logout?redirect=%2Fregistrazione">logout</Link>.
    </span>
  ) : (
    <div className="registrazione">
      <h1>Registrazione utente</h1>
      <hr />
      <div id="registrazione">
        <h3 className="pb-3">Inserisci le tue informazioni</h3>
        <Row className="px-5">
          <Col lg="6">
            <Form
              id="registrazione-form"
              className="auth-form"
              formFields={formFields}
              onSubmit={registrazioneSubmit}
              initialValues={initialValues}
            />
          </Col>
          <Col lg="6" className="text-center">
            {/* <h4>Oppure registrati con il tuo profilo social</h4> */}
          </Col>
        </Row>
      </div>
    </div>
  );
}
